import { Injectable } from '@angular/core';

import { environment } from '../../../environments/environment';

type LogLevel = 'debug' | 'info' | 'warn' | 'error';

@Injectable({ providedIn: 'root' })
export class AppLoggerService {
  private readonly enabled = !environment.production;

  debug(event: string, payload?: unknown, context?: string): void {
    this.log('debug', event, payload, context);
  }

  info(event: string, payload?: unknown, context?: string): void {
    this.log('info', event, payload, context);
  }

  warn(event: string, payload?: unknown, context?: string): void {
    this.log('warn', event, payload, context);
  }

  error(event: string, payload?: unknown, context?: string): void {
    this.log('error', event, payload, context);
  }

  private log(level: LogLevel, event: string, payload?: unknown, context?: string): void {
    if (!this.enabled) {
      return;
    }
    const prefix = context ? `[${context}]` : '[App]';
    const message = `${prefix} ${event}`;
    if (payload === undefined) {
      console[level](message);
      return;
    }
    console[level](message, payload);
  }
}
